import * as THREE from 'three'

import Experience from '../Experience.js'

export default class Sphere {
  constructor (x, y, z, name) {
    this.experience = new Experience()
    this.scene = this.experience.scene
    this.time = this.experience.time
    this.debug = this.experience.debug

    this.name = name

    this.ENTIRE_SCENE = 0
    this.BLOOMSCENE = 1

    this.setGeometry()
    // this.setTextures();
    this.setMaterial()
    this.setMesh(x, y, z, name)

    this.setGUI()
  }

  setGeometry () {
    this.geometry = new THREE.SphereGeometry(10, 32, 16)
  }

  setTextures () {
    this.textures = {}

    this.textures.color = new THREE.Color()
    this.textures.color.setHSL(Math.random(), 0.7, Math.random() * 0.2 + 0.05)
  }

  setMaterial () {
    this.color = new THREE.Color(0x000fff)
    // this.color.setHSL(Math.random(), 0.7, Math.random() * 0.2 + 0.05)

    /*   this.darkMaterial = new THREE.MeshBasicMaterial({ color: 'black' })
    this.materials = {} */

    this.material = new THREE.MeshStandardMaterial({
      color: this.color,
      transparent: true,
      opacity: 0,
      emissive: this.color,
      shininess: 16,
      specular: 0xa7a7a7
    })
  }

  setMesh (x, y, z, name) {
    const material2 = new THREE.MeshBasicMaterial({ color: 'green' })
    this.mesh = new THREE.Mesh(this.geometry, this.material)
    this.mesh.position.set(x, y, z)
    this.mesh.castShadow = true
    this.mesh.receiveShadow = true
    this.mesh.name = name
    this.scene.add(this.mesh)

    /* if (Math.random() < 0.5)
      this.mesh.layers.enable(this.BLOOMSCENE) */

    // console.log(this.mesh.layers)
  }

  setGUI () {
    const params = {
      color: 0xffffff
    }

    this.debugFolder = this.debug.ui.addFolder('sphere')
    this.debugFolder.addColor(params, 'color').onChange(() => {
      this.material.color.set(params.color)
      // this.material.emissive.set(params.color)
    })
    const positionFolder = this.debugFolder.addFolder('position')
    positionFolder.add(this.mesh.position, 'x', -1000, 1000)
    positionFolder.add(this.mesh.position, 'y', -1000, 1000)
    positionFolder.add(this.mesh.position, 'z', -2000, 1000)
  }

  update () {
    this.mesh.position.y = Math.sin(this.time.elapsed * 0.001) * 50
  }
}
